var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.selectedIndexesArray
    ? _c(
        "div",
        {
          staticClass: "trp-controls-section-content",
          attrs: { id: "trp-translation-section" }
        },
        [
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.showChangesUnsavedMessage,
                  expression: "showChangesUnsavedMessage"
                }
              ],
              staticClass: "trp-changes-unsaved-message"
            },
            [
              _vm._v(_vm._s(_vm.editorStrings.unsaved_changes) + " "),
              _c(
                "span",
                {
                  staticClass: "trp-unsaved-changes trp-discard-changes ",
                  attrs: { title: _vm.editorStrings.discard_all_title_attr },
                  on: { click: _vm.discardAll }
                },
                [_vm._v(_vm._s(_vm.editorStrings.discard_all))]
              ),
              _vm._v("?")
            ]
          ),
          _vm._v(" "),
          _vm._l(_vm.languages, function(languageCode, key) {
            return _c(
              "div",
              { attrs: { id: "trp-language-" + languageCode } },
              [
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value:
                          (key <= _vm.othersButtonPosition ||
                            _vm.showOtherLanguages) &&
                          (_vm.selectedIndexesArray &&
                            _vm.selectedIndexesArray.length > 0),
                        expression:
                          "( (key <= othersButtonPosition) || showOtherLanguages ) && ( selectedIndexesArray && selectedIndexesArray.length > 0 )"
                      }
                    ],
                    staticClass: "trp-language-container"
                  },
                  [
                    _c("div", { staticClass: "trp-language-name" }, [
                      key == 0
                        ? _c("span", [
                            _vm._v(_vm._s(_vm.editorStrings.from) + " ")
                          ])
                        : _c("span", [
                            _vm._v(_vm._s(_vm.editorStrings.to) + " ")
                          ]),
                      _vm._v(
                        "\n                " +
                          _vm._s(_vm.completeLanguageNames[languageCode]) +
                          "\n                "
                      ),
                      languageCode != "original"
                        ? _c("img", {
                            staticClass: "trp-language-box-flag-image",
                            attrs: {
                              src:
                                _vm.flagsPath[languageCode] +
                                "/" +
                                languageCode +
                                ".png",
                              width: "18",
                              height: "12",
                              alt: languageCode,
                              title: _vm.completeLanguageNames[languageCode]
                            }
                          })
                        : _vm._e()
                    ]),
                    _vm._v(" "),
                    _c(
                      "table",
                      { staticClass: "trp-translations-for-language" },
                      [
                        _vm.showImageIcon
                          ? _c(
                              "td",
                              { staticClass: "trp-translation-icon-container" },
                              [
                                _c("span", {
                                  staticClass:
                                    "trp-translation-icon dashicons dashicons-format-image"
                                })
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "td",
                          { staticClass: "trp-translations-container" },
                          _vm._l(_vm.selectedIndexesArray, function(
                            selectedIndex
                          ) {
                            return _c(
                              "div",
                              { staticClass: "trp-string-container" },
                              [
                                _vm.dictionary[selectedIndex] &&
                                _vm.dictionary[selectedIndex].translationsArray[
                                  languageCode
                                ]
                                  ? _c(
                                      "div",
                                      { key: selectedIndex },
                                      [
                                        _c("translation-input", {
                                          attrs: {
                                            string:
                                              _vm.dictionary[selectedIndex],
                                            highlightUnsavedChanges:
                                              _vm.showChangesUnsavedMessage &&
                                              _vm.hasUnsavedChanges(
                                                selectedIndex,
                                                languageCode
                                              ),
                                            editorStrings: _vm.editorStrings
                                          },
                                          model: {
                                            value:
                                              _vm.dictionary[selectedIndex]
                                                .translationsArray[languageCode]
                                                .editedTranslation,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.dictionary[selectedIndex]
                                                  .translationsArray[
                                                  languageCode
                                                ],
                                                "editedTranslation",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "dictionary[selectedIndex].translationsArray[languageCode].editedTranslation"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  : _vm.dictionary[selectedIndex]
                                  ? _c(
                                      "div",
                                      { key: selectedIndex },
                                      [
                                        _c("translation-input", {
                                          attrs: {
                                            readonly: true,
                                            string:
                                              _vm.dictionary[selectedIndex],
                                            value:
                                              _vm.dictionary[selectedIndex]
                                                .original,
                                            editorStrings: _vm.editorStrings
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass: "trp-translation-input-footer",
                                    attrs: {
                                      "data-dictionary-entry": JSON.stringify(
                                        _vm.dictionary[selectedIndex]
                                      )
                                    }
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        directives: [
                                          {
                                            name: "show",
                                            rawName: "v-show",
                                            value:
                                              _vm.dictionary[selectedIndex]
                                                .attribute != "content" ||
                                              _vm.dictionary[selectedIndex]
                                                .attribute != "",
                                            expression:
                                              "dictionary[selectedIndex].attribute != 'content' || dictionary[selectedIndex].attribute != ''"
                                          }
                                        ],
                                        staticClass: "trp-attribute-name"
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.editorStrings[
                                              _vm.dictionary[selectedIndex]
                                                .attribute
                                            ]
                                              ? _vm.editorStrings[
                                                  _vm.dictionary[selectedIndex]
                                                    .attribute
                                                ]
                                              : _vm.editorStrings.text
                                          )
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _vm.dictionary[selectedIndex] &&
                                    _vm.dictionary[selectedIndex]
                                      .translationsArray[languageCode]
                                      ? _c(
                                          "div",
                                          {
                                            staticClass:
                                              "trp-discard-changes trp-discard-individual-changes",
                                            class: {
                                              "trp-unsaved-changes": _vm.hasUnsavedChanges(
                                                selectedIndex,
                                                languageCode
                                              )
                                            },
                                            attrs: {
                                              title:
                                                _vm.editorStrings
                                                  .discard_individual_changes_title_attribute
                                            },
                                            on: {
                                              click: function($event) {
                                                _vm.discardChanges(
                                                  selectedIndex,
                                                  languageCode
                                                )
                                              }
                                            }
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(_vm.editorStrings.discard)
                                            )
                                          ]
                                        )
                                      : _vm._e()
                                  ]
                                ),
                                _vm._v(" "),
                                _vm.dictionary[selectedIndex] &&
                                _vm.dictionary[selectedIndex].translationsArray[
                                  languageCode
                                ]
                                  ? _c(
                                      "div",
                                      {
                                        key: selectedIndex,
                                        staticClass:
                                          "trp-translation-memory-wrap"
                                      },
                                      [
                                        _c("translation-memory", {
                                          attrs: {
                                            string:
                                              _vm.dictionary[selectedIndex],
                                            editorStrings: _vm.editorStrings,
                                            ajax_url: _vm.ajax_url,
                                            nonces: _vm.nonces,
                                            languageCode: languageCode
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  : _vm._e()
                              ]
                            )
                          }),
                          0
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: key == _vm.othersButtonPosition,
                            expression: "key == othersButtonPosition"
                          }
                        ]
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "trp-toggle-languages",
                            class: {
                              "trp-show-other-languages":
                                _vm.showOtherLanguages,
                              "trp-hide-other-languages": !_vm.showOtherLanguages
                            },
                            on: {
                              click: function($event) {
                                _vm.showOtherLanguages = !_vm.showOtherLanguages
                              }
                            }
                          },
                          [
                            _c("span", [
                              _vm._v(
                                _vm._s(_vm.showOtherLanguages ? "⯆" : "⯈") +
                                  " " +
                                  _vm._s(_vm.editorStrings.other_lang)
                              )
                            ])
                          ]
                        )
                      ]
                    )
                  ]
                )
              ]
            )
          })
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }